import TripReportList from './trip_report_list';

export default TripReportList;
